<template>
  <div class="search-container">
    <div class="search-content">
      <div class="search-top">
        <i class="el-icon-close close-icon" @click="cancleDelete"></i>
          选择客户
      </div>
      <el-form class="form-container" @submit.native.prevent>
        <el-form-item class="input-list" label="公司名称或姓名" prop="company_name">
          <el-input type="text" placeholder="请输入回车选择" v-model="company_name" @keyup.enter.native = "searchCompany"></el-input><!--  @input="searchCompany" -->
        </el-form-item>
        <div class="company-container">
          <el-table
            border
            max-height="200"
            :data="companyList"
            @row-click="chooseOrder"
            :row-style="selectBg"
            class="company">
            <el-table-column fixed prop="company_name" label="公司名称"></el-table-column>
            <el-table-column prop="user_name" label="姓名"></el-table-column>
          </el-table>
        </div>
        <el-form-item class="btn-content">
          <el-button class="btn-list cancle-btn" @click="cancleDelete">取消</el-button>
          <el-button class="btn-list btn-save" @click="addNewOrder">确定</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script type='text/ecmascript-6'>
export default {
  data () {
    return {
      company_name: '', // 请输入公司名称
      companyList: [],
      company: {},
      rowIndex: ''
    }
  },
  methods: {
    selectBg({ rowIndex }) { // 设置表格第一行的颜色
      if (rowIndex === this.rowIndex) {
        return 'background:#ECF0F8'
      } else {
        return ''
      }
    },
    cancleDelete () { // 取消删除
      this.$emit('closeorder', ' ')
      /* this.$message({
        type: 'info',
        message: '取消添加订单！',
        customClass: 'msg-position',
        showClose: true
      }) */
    },
    searchCompany () { // 输入框的 input ⌚事件
      let that = this
      if (that.company_name) {
        this.$api.searchCompany({
          name: that.company_name
        }).then(res => {
          if (res.data.length > 0) {
            that.companyList = res.data.map((item, index) => {
              item.index = index
              return item
            })
          } else {
            that.companyList = []
            that.$message({
              message: '该公司没有快速下单的订单',
              type: 'error',
              customClass: 'msg-position',
              showClose: true
            })
          }
        }).catch(e => {
          that.$message({
            message: `${e}`,
            type: 'error',
            customClass: 'msg-position',
            showClose: true
          })
        })
      } else {
        that.$message({
          message: '输入不能为空！',
          type: 'error',
          customClass: 'msg-position',
          showClose: true
        })
      }
    },
    chooseOrder(row) {
      this.rowIndex = row.index
      this.company = row
    },
    addNewOrder () {
      let that = this
      //let index = this.company_index
      if (that.company.open_id) {
        this.$api.createOrder({
          open_id: that.company.open_id
        }).then(res => {
          if (res.data.msg == true) {
            that.company.order_id = res.data.order_id
            this.$emit('closeorder', that.company)
          } else {
            that.$message({
              type: 'error',
              message: '创建订单失败',
              customClass: 'msg-position',
              showClose: true
            })
          }
        }).catch(e => {
          this.$message({
            type: 'error',
            message: `${e}`,
            customClass: 'msg-position',
            showClose: true
          })
        })
      } else {
        that.$message({
          message: '请选择要创建的订单',
          type: 'error',
          customClass: 'msg-position',
          showClose: true
        })
      }
    }
  }
}
</script>

<style lang='stylus' rel='stylesheet/stylus'>
.search-container
  position:fixed;
  left:0;
  right:0;
  top:0;
  bottom:0;
  background-color:rgba(0, 0, 0, 0.2);
  z-index:10000;
  display: flex;
  justify-content: center;
  align-items: center;
  .search-content
    background:#fff;
    z-index: 100001;
    width: 24rem;
    padding: 0rem;
    border-radius: 0.4rem;
    position: relative;
    overflow:hidden;
    .search-top
      line-height: 3rem;
      background: #1D489E;
      color: #fff;
      font-size:0.8rem;
      text-align: center;
      font-weight:bold;
    .form-container
      border: 0;
      padding: 2rem;
      .input-list
        display: flex;
        margin-bottom: 1rem;
        &.is-error
          .el-form-item__content
            .el-input
              .el-input__inner
                border: 0.05rem solid #EF757A;
        .el-form-item__label
          color:#474747;
          font-size:0.7rem
          flex: 0 0 6rem;
          text-align: left;
        .el-form-item__content
          position:relative;
          height:2rem;
          flex: 1;
          .el-input
            height:2rem;
            .el-input__inner
              padding: 0 0.8rem;
              border: 0.05rem solid #cfcfcf;
          .el-form-item__error
            /* top:0.5rem; */
            left: 0.8rem;
            background:#fff;
            color:#EF757A;
      .btn-content
        width:100%;
        padding:0;
        margin-top:1rem;
        margin-bottom:0;
        .el-form-item__content
          display: flex;
          width:100%;
          .btn-list
            flex:1;
            height: 2rem;
            &.btn-save
              background:#1D489E;
              span
                color:#fff;
            &.cancle-btn
              background: #cfcfcf;
              color:#fff;
              span
                color:#fff;
      .company-container
        max-height: 10rem;
        overflow:hidden;
        .company
          overflow-y: auto;
          .company-list
            height: 2rem;
            line-height: 2rem;
            font-size:0.7rem;
            padding: 0 0.5rem;
            border-bottom: 0.05rem solid #cfcfcf;
            color: #666;
            &:last-child
              border:0;
            &.company-select
              color: #fff;
              background: #1D489E;
        .none-content
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          margin: 1rem 0;
          .none-title
            font-size: 0.7rem;
            color:#666;
    .close-icon
      position: absolute;
      top:0.5rem;
      right:0.5rem;
      color:#fff;
      font-size:1.2rem;
</style>
